import { FC } from 'react';

import { ForgotPasswordForm } from './ForgotPasswordForm';
import {
    Card,
    CardDescription,
    CardHeader,
    CardTitle,
} from '../../components/ui/Card';

const ForgotPassword: FC = () => (
    <div className="flex w-full items-center justify-center lg:w-1/2 lg:p-8 xl:w-1/3">
        <div className="mx-auto w-full max-w-sm space-y-6">
            <Card className="w-full rounded-2xl border-0 shadow-none sm:border sm:shadow-lg">
                <CardHeader className="space-y-1 pb-4 text-center sm:pb-6">
                    <CardTitle className="text-2xl font-bold sm:text-3xl">
                        Відновлення паролю
                    </CardTitle>
                    <CardDescription className="text-sm text-muted-foreground">
                        Введіть вашу електронну пошту, щоб отримати інструкції з
                        відновлення паролю
                    </CardDescription>
                </CardHeader>

                <ForgotPasswordForm />
            </Card>
        </div>
    </div>
);

export default ForgotPassword;
